export default __webpack_public_path__ + "static/media/Entrepreneur.bd7c2804.svg";